/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneTracking as ResolvedStandaloneTracking } from 'base/components/standalone/Tracking';

export const Tracking: typeof ResolvedStandaloneTracking = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneTracking {...props} />
        </ErrorBoundary>
    );
});

export type TrackingProps = PropsFromComponent<typeof Tracking>;

/** @deprecated Use slot architecture instead */
export const TrackingWith = (extras: DynamicStandaloneExtras): typeof Tracking => {
    return function Tracking(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Tracking');
        return <ResolvedStandaloneTracking {...mergeProps({ options: { theme } }, props)} />;
    }
}